var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current)?_c('router-link',{class:_vm.alias,attrs:{"to":{name: 'currentPage', params:{cid: _vm.currentId}}}},[_vm._v("\r\n"+_vm._s(_vm.current.label)+"\r\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }